module.exports = __webpack_public_path__ + "media/promo/panasonic/images/icons/i-4-209cde19723c16fe16885015f4a5da19.svg";